// 组件对象，大写
import readTextTwo from './readTextTwo.vue'
export default readTextTwo
